import React from 'react';
import { useNavigate } from '@tanstack/react-router';

import AuthEmailSent from '@/components/organism/Login/AuthEmailSent';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();

  const handleProceed = () => {
    void navigate({ to: '/reset-password/otp-verify' });
  };

  return <AuthEmailSent onProceed={handleProceed} />;
};

export default ForgotPassword;
